// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.OfflineSync_pendientes__Pm0iN {
  position: fixed;
  bottom: calc(var(--nav-height) + 8px);
  left: 50%;
  transform: translateX(-50%);
  z-index: 1050;
  display: flex;
  align-items: center;
  gap: 0.4rem;
  max-width: 92vw;
  padding: 0.4rem 0.85rem;
  border-radius: 999px;
  background: #b45309;
  color: #fff;
  font-size: 0.78rem;
  font-weight: 600;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.25);
  white-space: nowrap;
}
.OfflineSync_pendientes__Pm0iN i {
  font-size: 0.95rem;
}`, "",{"version":3,"sources":["webpack://./src/templates/partials/OfflineSync/OfflineSync.module.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;EACA,qCAAA;EACA,SAAA;EACA,2BAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;EACA,uBAAA;EACA,oBAAA;EACA,mBAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,yCAAA;EACA,mBAAA;AACJ;AACI;EACI,kBAAA;AACR","sourcesContent":[".pendientes {\n    position: fixed;\n    bottom: calc(var(--nav-height) + 8px); // por encima de la navbar inferior\n    left: 50%;\n    transform: translateX(-50%);\n    z-index: 1050;\n    display: flex;\n    align-items: center;\n    gap: 0.4rem;\n    max-width: 92vw;\n    padding: 0.4rem 0.85rem;\n    border-radius: 999px;\n    background: #b45309;\n    color: #fff;\n    font-size: 0.78rem;\n    font-weight: 600;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.25);\n    white-space: nowrap;\n\n    i {\n        font-size: 0.95rem;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pendientes": `OfflineSync_pendientes__Pm0iN`
};
export default ___CSS_LOADER_EXPORT___;
